import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import { StatusBadge } from "../components/StatusBadge";
import api from "../lib/api";
import { formatGs } from "../lib/format";
import { PackageOpen } from "lucide-react";
import { SearchBox, matchQ } from "../components/SearchBox";

const ALMACEN = ["depositado_origen", "en_sucursal_destino", "desembarcado", "almacenado"];

export default function Almacenamiento() {
  const { setMobileOpen } = useOutletContext();
  const [envios, setEnvios] = useState([]);
  const [q, setQ] = useState("");
  const load = useCallback(() => { api.get("/envios").then(({ data }) => setEnvios(data.filter((e) => ALMACEN.includes(e.status)))).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <>
      <Header title="Almacenamiento" subtitle="Paquetes en depósito y sucursales · 10 días hábiles gratis, luego Gs. 10.000/día (máx. 14 días)" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8">
        <SearchBox value={q} onChange={setQ} testid="almacen-search" />
        <div className="bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2 font-semibold text-[#0A1F44]"><PackageOpen className="h-4 w-4 text-[#F5A623]" /> En almacén ({envios.length})</div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[#64748B] text-xs uppercase"><tr><th className="text-left font-semibold px-4 py-3">Código</th><th className="text-left font-semibold px-4 py-3">Destinatario</th><th className="text-left font-semibold px-4 py-3 hidden sm:table-cell">Ubicación</th><th className="text-left font-semibold px-4 py-3">Estado</th><th className="text-right font-semibold px-4 py-3">Almacenaje</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {envios.filter(matchQ(q)).map((e) => (
                  <tr key={e.id} className="hover:bg-slate-50/60" data-testid={`almacen-row-${e.code}`}>
                    <td className="px-4 py-3 font-mono font-bold text-xs">{e.code}</td>
                    <td className="px-4 py-3">{e.destinatario} · {e.ciudad}</td>
                    <td className="px-4 py-3 hidden sm:table-cell text-xs text-[#64748B]">{e.sucursal_destino || e.sucursal_origen}</td>
                    <td className="px-4 py-3"><StatusBadge status={e.status} /></td>
                    <td className="px-4 py-3 text-right">
                      {e.almacenamiento ? (
                        <div data-testid={`almacen-costo-${e.code}`}>
                          <div className={`font-bold ${e.almacenamiento.dias_costo > 0 ? "text-rose-600" : "text-emerald-700"}`}>{formatGs(e.almacenamiento.importe)}</div>
                          <div className="text-[11px] text-[#64748B]">{e.almacenamiento.dias_habiles} días hábiles · gratis hasta {e.almacenamiento.gratis_hasta}</div>
                          <div className={`text-[11px] font-semibold ${e.almacenamiento.vencido ? "text-rose-600" : "text-amber-700"}`}>{e.almacenamiento.vencido ? "VENCIDO · " : ""}límite {e.almacenamiento.limite}</div>
                        </div>
                      ) : <span className="text-xs text-[#64748B]">—</span>}
                    </td>
                  </tr>
                ))}
                {envios.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-[#64748B]">No hay paquetes en almacén.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </>
  );
}
